import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup__close" }


export default /*@__PURE__*/_defineComponent({
  __name: 'KindleNotification',
  props: {
    show: { type: Boolean }
  },
  emits: ["toggleShow"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleShow')))
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "v-fade book-export__notification",
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleShow')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "book-export__kindle-popup-close-icon iconfont iclose-thin" }, null, -1)
        ]))])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "book-export__notification-title" }, " We've sent the guide to your Kindle device "),
        _createElementVNode("p", { class: "book-export__notification-text" }, " You may get an email with the subject line \"Verify your Kindle document\". ")
      ], -1))
    ], 512), [
      [_vShow, __props.show]
    ])
  ]))
}
}

})